(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7440],{

/***/ 13602:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/thi-gplx/thi-that",
      function () {
        return __webpack_require__(65057);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 65057:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSG": function() { return /* binding */ __N_SSG; },
/* harmony export */   "default": function() { return /* binding */ Start; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(14924);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material_styles__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(11496);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _layouts__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85307);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _assets_licenseDetails_json__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(71798);
/* harmony import */ var _components_Page__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(82771);
/* harmony import */ var _hooks_useLocales__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(9671);
/* harmony import */ var _redux_slices_gplx_exam_slice__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(3955);
/* harmony import */ var _redux_slices_gplx_quiz__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(44326);
/* harmony import */ var _redux_store__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(33599);
/* harmony import */ var _iconify_react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(1954);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(27948);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(87357);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(86886);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(15861);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(26447);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(49624);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(13362);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(83321);
/* harmony import */ var _components_Image__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(65907);
/* harmony import */ var _hooks_useSettings__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(40571);
// @mui






// layouts

// components







// sections




var RootStyle = (0,_mui_material_styles__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .ZP)("div")(function(param) {
    var theme = param.theme;
    return (0,_swc_helpers_src_define_property_mjs__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z)({
        paddingTop: theme.spacing(10),
        paddingBottom: theme.spacing(10)
    }, theme.breakpoints.up("md"), {
        paddingTop: theme.spacing(15),
        paddingBottom: theme.spacing(15)
    });
});
var gplx = [
    {
        label: "A1",
        index: 0
    },
    {
        label: "A2",
        index: 1
    },
    {
        label: "A3",
        index: 2
    },
    {
        label: "A4",
        index: 3
    },
    {
        label: "B1",
        index: 4
    },
    {
        label: "B2",
        index: 5
    },
    {
        label: "C",
        index: 6
    },
    {
        label: "D",
        index: 7
    },
    {
        label: "E",
        index: 8
    },
    {
        label: "F",
        index: 9
    }, 
];
Start.getLayout = function getLayout(page) {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_layouts__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        variant: "main",
        children: page
    });
};
var __N_SSG = true;
function Start(param) {
    var exams = param.exams;
    var getRandomInt = function getRandomInt(min, max) {
        min = Math.ceil(min);
        max = Math.floor(max);
        return Math.floor(Math.random() * (max - min + 1)) + min;
    };
    var themeStretch = (0,_hooks_useSettings__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)().themeStretch;
    var translate = (0,_hooks_useLocales__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)().translate;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_3__.useRouter)();
    var dispatch = (0,_redux_store__WEBPACK_IMPORTED_MODULE_9__/* .useDispatch */ .I0)();
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(gplx[0]), value = ref[0], setValue = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(_assets_licenseDetails_json__WEBPACK_IMPORTED_MODULE_4__[0].totalExams), totalExams = ref1[0], setTotalExams = ref1[1];
    var handleChange = function(value) {
        setValue(value);
        if (value === "") {
            setTotalExams(_assets_licenseDetails_json__WEBPACK_IMPORTED_MODULE_4__[value.index].totalExams);
        }
    };
    var handleReady = function() {
        var examIndex = getRandomInt(1, totalExams);
        dispatch((0,_redux_slices_gplx_quiz__WEBPACK_IMPORTED_MODULE_8__/* .setIndexLicenserReal */ .jP)({
            index: value.index,
            examIndex: examIndex,
            time: _assets_licenseDetails_json__WEBPACK_IMPORTED_MODULE_4__[value.index].time,
            require: {
                correctAnswer: _assets_licenseDetails_json__WEBPACK_IMPORTED_MODULE_4__[value.index].correctAnswer,
                name: _assets_licenseDetails_json__WEBPACK_IMPORTED_MODULE_4__[value.index].name
            }
        }));
        router.push("/thi-gplx/thi-that/".concat(examIndex));
    };
    var handleReadySituation = function() {
        var idx = getRandomInt(0, exams.length - 1);
        var slug = exams[idx].slug;
        dispatch((0,_redux_slices_gplx_exam_slice__WEBPACK_IMPORTED_MODULE_7__/* .removeFlags */ .M1)());
        router.push("/thi-tinh-huong/thi-that/".concat(slug));
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Page__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        title: translate("realHome.title"),
        description: translate("realHome.description"),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_15__/* ["default"] */ .Z, {
            maxWidth: themeStretch ? "xl" : "lg",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(RootStyle, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                    border: "2px solid #05163b",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Image__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {
                            src: "/illustrations/banner-exam.jpg",
                            height: 50
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .ZP, {
                            container: true,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .ZP, {
                                    item: true,
                                    sm: 6,
                                    xs: 12,
                                    border: "2px solid #05163b",
                                    p: 1,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                            my: 2,
                                            variant: "h3",
                                            textAlign: "center",
                                            children: "THI L\xdd THUYẾT"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                            direction: "row",
                                            spacing: 1,
                                            alignItems: "center",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                                    variant: "subtitle1",
                                                    children: "Hạng GPLX:"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                                    value: value,
                                                    onChange: function(_, newValue) {
                                                        return handleChange(newValue);
                                                    },
                                                    id: "gplx",
                                                    options: gplx,
                                                    getOptionLabel: function(option) {
                                                        return option.label;
                                                    },
                                                    renderInput: function(params) {
                                                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_23__/* ["default"] */ .Z)({}, params), {
                                                            label: "Chọn hạng bằng"
                                                        }));
                                                    }
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                                                    label: "Điền số b\xe1o danh của bạn"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z, {
                                            sx: {
                                                ml: 12,
                                                my: 3
                                            },
                                            variant: "contained",
                                            onClick: handleReady,
                                            startIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_iconify_react__WEBPACK_IMPORTED_MODULE_10__/* .Icon */ .JO, {
                                                icon: "simple-line-icons:login"
                                            }),
                                            children: "Bắt đầu"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_17__/* ["default"] */ .ZP, {
                                    item: true,
                                    sm: 6,
                                    xs: 12,
                                    border: "2px solid #05163b",
                                    p: 1,
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                            my: 2,
                                            variant: "h3",
                                            textAlign: "center",
                                            children: "THI M\xd4 PHỎNG"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z, {
                                            direction: "row",
                                            spacing: 1,
                                            alignItems: "center",
                                            children: [
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                                    variant: "subtitle1",
                                                    children: "Số b\xe1o danh:"
                                                }),
                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                                                    label: "Điền số b\xe1o danh của bạn"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_24__/* ["default"] */ .Z, {
                                            sx: {
                                                ml: 12,
                                                my: 3
                                            },
                                            variant: "contained",
                                            onClick: handleReadySituation,
                                            startIcon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_iconify_react__WEBPACK_IMPORTED_MODULE_10__/* .Icon */ .JO, {
                                                icon: "simple-line-icons:login"
                                            }),
                                            children: "Bắt đầu"
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            })
        })
    });
}


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [5101,1160,3362,9624,3559,9774,2888,179], function() { return __webpack_exec__(13602); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);